var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCameraDomeOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "#"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 9L3.04055 6.45683C2.85119 5.72675 3.34883 5 4.03811 5H10.8M4 9V11.381C4 15.5888 7.58172 19 12 19C15.8349 19 19.0396 16.4301 19.819 13M4 9H11.4M14 14C14 15.1 13.1 16 12 16C10.9 16 10 15.1 10 14C10 12.9 10.9 12 12 12C13.1 12 14 12.9 14 14Z",
    stroke: "black",
    strokeOpacity: 0.77,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11C20.7614 11 23 8.76142 23 6C23 3.23858 20.7614 1 18 1C15.2386 1 13 3.23858 13 6C13 8.76142 15.2386 11 18 11ZM20.967 4.99729C21.251 4.70682 21.251 4.23587 20.967 3.94539C20.683 3.65492 20.2225 3.65492 19.9385 3.94539L17.4831 6.4773L16.0579 5.01977C15.7739 4.7293 15.3134 4.7293 15.0294 5.01977C14.7454 5.31025 14.7454 5.7812 15.0294 6.07167L16.9688 8.05514C17.2528 8.34561 17.7133 8.34561 17.9973 8.05514L20.967 4.99729Z",
    fill: "#56AB50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1816_3374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraDomeOnline);
export default __webpack_public_path__ + "static/media/icon-camera-dome-online.a6136ef13ba1042aea8a66160ba2920f.svg";
export { ForwardRef as ReactComponent };